import React, { Component } from "react";
import "../../css/syte.css";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import Box from "./Box";
import syteSearch from "../../images/Camera Dot_Br.svg";

class ProductBox extends Component {
  state = {
    productsLists: null
  };
  render() {
    const {
      productRefinements,
      noSearchResult,
      searchProductList,
      keywords
    } = this.props;
    return (
      <div>
        <div className="search-item-quantity">
          <Translation>{t => <>{t("searchPage.foundtc")}</>}</Translation>
          {productRefinements
            ? productRefinements.productListPageInfo.totalNumberOfResults
            : "0"}
          {productRefinements ? (
            productRefinements.productList.length === 0 ? (
              <Translation>{t => <>{t("searchPage.item")}</>}</Translation>
            ) : (
              <Translation>{t => <>{t("searchPage.items")}</>}</Translation>
            )
          ) : (
            <Translation>{t => <>{t("searchPage.item")}</>}</Translation>
          )}
          &nbsp;
          <Translation>{t => <>{t("searchPage.found")}</>}</Translation>
        </div>
        {productRefinements ? (
          <div className="products-result-wrap">
            {searchProductList.map((data, index) => (
              <Box data={data} key={index} keywords={keywords} />
            ))}
          </div>
        ) : null}
        {noSearchResult ? (
          <div className="search-error-content">
            <Translation>{t => <>{t("searchBar.noResult")}</>}</Translation>
            &nbsp;"
            {this.props.keywords}"
            <Translation>{t => <>{t("searchBar.dot")}</>}</Translation>
            {/* syte 以圖搜圖 search result*/}
            {/* 暫時移除syte相關模組 */}
            {/* <button
              href="javascript:void(0)"
              className="--syte-start-camera-upload search-result-syte-start-camera-upload"
              data-camera-button-placement="no-search-results"
            >
              <img className="img-camera" src={syteSearch} alt="" />
              <Translation>{t => <>{t("searchBar.syteSearch")}</>}</Translation>
            </button> */}
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    scale: state.scaleProduct.scale,
    productRefinements: state.searchKeywords.productRefinements,
    noSearchResult: state.searchKeywords.noSearchResult,
    searchProductList: state.searchKeywords.searchProductList
  };
};

export default connect(mapStateToProps, null)(ProductBox);
